import React from 'react'
import TabAddPackages from './page-components/pacakges/TabAddPackages'
import TabViewPacakges from './page-components/pacakges/TabViewPacakges'
import MasterPageTab from './page-essential/MasterPageTab'
import SideNav from './page-essential/SideNav'

const Packages = () => {
    return (
        <MasterPageTab addBtn='Add package' viewBtn='View packages' addTab={<TabAddPackages />} viewTab={<TabViewPacakges />} pageHeading={"Packages"} pageDescription='Add/view/modify packages' icon={null} />

    )
}

export default Packages